import { Link } from "react-router-dom";

export default function MidCTA() {
  return (
    <section className="relative py-24 lg:py-0 overflow-hidden min-h-[500px] lg:min-h-[600px] flex items-center">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b9aaae0b6863197dae5b757204cc07be.jpg"
          alt="Request consultation Studio 1323"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div className="relative z-10 w-full px-8 lg:px-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
        <div className="max-w-xl">
          <p className="text-white/50 text-xs tracking-[0.25em] uppercase mb-4">Ready to Begin?</p>
          <h2 className="font-serif text-4xl lg:text-6xl text-white font-light leading-tight">
            Let&apos;s discuss<br />
            <em>your vision.</em>
          </h2>
          <p className="mt-4 text-white/60 text-sm font-light leading-relaxed max-w-md">
            Whether you&apos;re building a new home, developing a multi-family project, or renovating an existing space — the first conversation is free.
          </p>
        </div>
        <div className="flex flex-col items-start lg:items-end gap-4">
          <Link
            to="/contact"
            className="inline-flex items-center gap-3 bg-white text-arch-charcoal px-8 py-4 text-xs tracking-[0.15em] uppercase font-semibold hover:bg-white/90 transition-all rounded-md cursor-pointer whitespace-nowrap"
          >
            Request Consultation
            <i className="ri-arrow-right-line text-base" />
          </Link>
          <p className="text-white/40 text-xs">
            Based in Santa Monica &nbsp;·&nbsp; Serving all of Los Angeles
          </p>
        </div>
      </div>
    </section>
  );
}
